export default "__VITE_ASSET__edyyJ$3F__"